import React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { bucketLabel } from './periods';

const UNIT = { day: 'per day', week: 'per week', month: 'per month' };

export const KpiChart = ({ series, unit }) => {
  const data = series.map((s) => ({ ...s, label: bucketLabel(s.bucket, unit) }));
  return (
    <div className="bg-white border rounded-xl p-4" data-testid="kpi-chart">
      <p className="font-semibold text-gray-900 mb-3">Visits & leads <span className="text-gray-400 font-normal text-sm">{UNIT[unit]}</span></p>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" minTickGap={12} />
            <YAxis yAxisId="v" tick={{ fontSize: 11 }} allowDecimals={false} />
            <YAxis yAxisId="l" orientation="right" tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar yAxisId="v" dataKey="visits" name="Visits" fill="#a7d7bd" radius={[4, 4, 0, 0]} />
            <Line yAxisId="l" dataKey="leads" name="Leads" stroke="#1a5c3b" strokeWidth={2.5} dot={{ r: 3 }} type="monotone" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
